import { render, staticRenderFns } from "./AffirmSort.vue?vue&type=template&id=a60b9b0c&"
import script from "./AffirmSort.vue?vue&type=script&lang=js&"
export * from "./AffirmSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports